import React from 'react';
import * as MuiCore from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import { useDispatch } from 'react-redux';
import { toggleWarmTransferAsync } from './actions';

export function WarmTransferForm({ warmTransferEnabled, accountId }) {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const dispatch = useDispatch();
    const handleSubmit = () => {
        setIsLoading(true);
        dispatch(toggleWarmTransferAsync(accountId));
    }
    return (
        <>

            <MuiCore.Accordion style={{ marginBottom: 2, backgroundColor: '#f5f5f5' }}>
                <MuiCore.AccordionSummary expandIcon={<Icons.ExpandMore />} aria-controls="warm-transfer-content" id="warm-transfer-header">
                    <MuiCore.Box style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}>
                        <MuiCore.Typography variant="body2" style={{ fontFamily: 'Sofia', marginRight: 6 }}>
                            <b>Warm Transfers</b>
                        </MuiCore.Typography>
                        <MuiCore.Chip
                            style={{
                                backgroundColor: warmTransferEnabled ? '#f9d58b' : '#ec2059',
                                color: warmTransferEnabled ? '#000' : '#fff',
                                fontFamily: 'Sofia'
                            }}
                            label={warmTransferEnabled ? 'ENABLED' : 'DISABLED'}
                        />
                    </MuiCore.Box>
                </MuiCore.AccordionSummary>
                <MuiCore.AccordionDetails>
                    <MuiCore.Box>

                        <MuiCore.Typography style={{ display: 'block', fontFamily: 'Sofia' }}>
                            <b>Warm Transfer: </b>Your Grasshopper AI will put callers on hold
                            while it connects to the recipient to perform an introduction and
                            request permission to transfer. If the recipient declines the
                            transfer, the bot will return to the caller to let them know the
                            recipient was unavailable. If the recipient accepts the transfer,
                            the bot will immediately connect the caller to the recipient.
                            <br />
                        </MuiCore.Typography>
                        <MuiCore.Typography style={{ display: 'block', fontFamily: 'Sofia' }}>
                            <b>Cold Transfer: </b>
                            Your Grasshopper AI will transfer callers directly to the recipient
                            without performing an introduction or requesting permission to
                            transfer.
                            <br />
                        </MuiCore.Typography>
                    </MuiCore.Box>
                </MuiCore.AccordionDetails>
                <MuiCore.AccordionActions>
                    <MuiCore.Button onClick={() => setOpen(true)} variant="contained" color={warmTransferEnabled ? "primary" : "default"} size="small">
                        {warmTransferEnabled ? 'Disable' : 'Enable'} warm transfers
                    </MuiCore.Button>
                </MuiCore.AccordionActions>
            </MuiCore.Accordion>
            <MuiCore.Dialog
                style={{ padding: 20 }}
                title={`${warmTransferEnabled ? 'Disable' : 'Enable'} Warm Transfers`}
                open={open}
                onClose={() => setOpen(false)}
                submitLoading={isLoading}
                cancelDisabled={isLoading}>
                <MuiCore.DialogContent>
                    <MuiCore.Typography variant="body1" style={{ fontFamily: 'Sofia' }}>
                        Are you sure you want to {warmTransferEnabled ? 'disable' : 'enable'}{' '}
                        warm transfers?
                    </MuiCore.Typography>
                </MuiCore.DialogContent>
                <MuiCore.DialogActions>
                    <MuiCore.Button onClick={() => setOpen(false)} disabled={isLoading}>
                        Cancel
                    </MuiCore.Button>
                    <MuiCore.Button onClick={handleSubmit} disabled={isLoading}>
                        Confirm
                    </MuiCore.Button>
                </MuiCore.DialogActions>
            </MuiCore.Dialog>
        </>
    );
}